import { observable } from "mobx";

export default class DetalhamentoHistoricoStore {
    @observable activeTab;

    constructor() {
        this.activeTab = '1';
    }

    toggle = (tab) => {
        if (this.activeTab !== tab) {
            this.activeTab = tab;
        }
    }

    tarefaPresenteTarefasRealizadas(tarefa, tarefasRealizadas){
        return tarefasRealizadas.filter(tr => tr.nomeTarefa == tarefa.nomeTarefa && tr.tipoFluxo == tarefa.tipoFluxo).length > 0;
    }

    tarefaCorrespondenteTarefasRealizadas(tarefa, tarefasRealizadas){
        return tarefasRealizadas.filter(tr => tr.nomeTarefa == tarefa.nomeTarefa && tr.tipoFluxo == tarefa.tipoFluxo)[0];
    }

    removerTarefasRealizadasFluxo(tarefasRealizadas, tarefasFluxo){
        return tarefasFluxo.filter( function( tarefa ) {
            return !(this.tarefaPresenteTarefasRealizadas(tarefa, tarefasRealizadas));
        } , this );
    }

    copiarResponsavel(tarefasRealizadas, tarefasFluxo){
        const tarefasFluxoCopy = JSON.parse(JSON.stringify(tarefasFluxo));
        return tarefasFluxoCopy.map( function( tarefa ) {
            const tarefaCorrespondente = this.tarefaCorrespondenteTarefasRealizadas(tarefa, tarefasRealizadas)
            if(tarefaCorrespondente !== undefined) {
                tarefa.historico = true;
                tarefa.nomeUsuarioResponsavel = tarefaCorrespondente.nomeUsuarioResponsavel;
            }
            return tarefa;
        } , this );
    }

    removerTarefasSemUsuario(tarefasFluxo){
        return tarefasFluxo.filter(tr => (tr.nomeUsuarioResponsavel !== null && tr.nomeUsuarioResponsavel !== "") || tr.tarefaAtual === true
            || tr.nomeTarefa === 'HT_ConfirmarAlocacao' || tr.nomeTarefa === 'HT_ConfirmarContratacaoETT');
    }

    removerTarefasNaoRealizadas(tarefasFluxo){
        let indexTarefaAtual = tarefasFluxo.findIndex(tarefa => tarefa.tarefaAtual === true);
        return tarefasFluxo.filter( function( tarefa, i ) {
            return( i >= indexTarefaAtual || tarefa.historico === true) ;
        } );
    }
}